import React, { useState } from 'react';
import { useModalContext } from '../../../../CustomModal/ModalProvider.jsx';
import ReactDOM from "react-dom/client";
import { format } from 'date-fns';
import { Card, CardHeader, CardContent, StyledButton, ButtonGrid } from './styles';
import FormRetirements from './FormRetirements/FormRetirements';
import ShowRetirements from './ShowRetirements/ShowRetirements';
import ShowProject from './ShowProject/ShowProject';
import ShowAsset from './ShowAsset/ShowAsset';
import { socialCarbonService } from '../../../../../services/socialCarbonService.js';

const AccountCard = ({ account }) => {
  const { showInfo, showError, showSuccess, showWarning, hideModal } = useModalContext();
  const [sessionData, setSessionData] = useState(null);

  const recarregar = async (email, password, pin) => {
    try {
      showInfo('Atualizando contas...', 'Por favor aguarde...');

      const token = sessionStorage.getItem('Authorization');

      // ✅ Usa o service padronizado
      const novaSessao = await socialCarbonService.getUserSession(
        { email, password, pin },
        token
      );

      setSessionData(novaSessao);
      hideModal();

    } catch (error) {
      console.error("❌ Erro ao recarregar sessão:", error.response?.data || error.message);
      hideModal();
      showError('Erro ao atualizar informações', 'Não foi possível atualizar a sessão do usuário.');
    }
  };

  const showAsset = async (account_address) => {
    try {
      const token = sessionStorage.getItem('Authorization');

      // ✅ Usa o service padronizado
      const data = await socialCarbonService.getAssets(account_address, token);
      const assets = data.assets;

      console.log('1', assets);

      if (assets.length > 0) {
        const assetContainer = document.createElement('div');
        document.body.appendChild(assetContainer);

        const root = ReactDOM.createRoot(assetContainer);
        root.render(
          <ShowAsset
            account_address={account_address}
            assets={assets}
            onClose={() => {
              root.unmount();
              document.body.removeChild(assetContainer);
            }}
          />
        );
      } else {
        showInfo('Nenhum asset encontrado', 'Não foram encontrados assets para esta conta.');
      }
    } catch (error) {
      console.error('Erro ao buscar assets:', error);
      showError('Erro', 'Ocorreu um erro ao buscar os assets.');
    }
  };

  const showProject = async (account_address) => {
    try {
      const token = sessionStorage.getItem('Authorization');

      // ✅ Usa o service centralizado
      const projectData = await socialCarbonService.getProjectsByAccount(account_address, token);
      const projects = projectData.projects;

      if (projects && projects.length > 0) {
        // Cria o container dinamicamente
        const projectContainer = document.createElement('div');
        document.body.appendChild(projectContainer);

        const root = ReactDOM.createRoot(projectContainer);
        root.render(
          <ShowProject
            projects={projects}
            onClose={() => {
              root.unmount();
              document.body.removeChild(projectContainer);
            }}
          />
        );
      } else {
        showInfo('Nenhum projeto encontrado', 'Não foram encontrados projetos para esta conta.');
      }
    } catch (error) {
      console.error('Erro ao exibir detalhes do projeto:', error);
      showError('Erro', 'Ocorreu um erro ao buscar os detalhes dos projetos.');
    }
  };

  const showRetirements = async (account_address) => {
    try {
      const token = sessionStorage.getItem('Authorization');

      // ✅ Usa o service centralizado
      const retirementData = await socialCarbonService.getRetirementsByAccount(account_address, token);
      const retirementProjects = retirementData.projects;

      if (retirementProjects && retirementProjects.length > 0) {
        const container = document.createElement('div');
        document.body.appendChild(container);

        const root = ReactDOM.createRoot(container);
        root.render(
          <ShowRetirements
            retirementProjects={retirementProjects}
            onClose={() => {
              root.unmount();
              document.body.removeChild(container);
            }}
          />
        );
      } else {
        showInfo('Nenhum projeto/aposentadoria encontrado', '');
      }
    } catch (error) {
      console.error('Erro completo:', error);
      showError('Erro', 'Ocorreu um erro ao buscar aposentadorias.');
    }
  };

  const showRetirementForm = async (credit_name, balance) => {
    try {
      if (balance <= 0) {
        showInfo('Sem Créditos', 'Nenhum crédito encontrado para ser aposentado.');
        return;
      }

      const retirementContainer = document.createElement('div');
      retirementContainer.id = 'retirement-form-container';
      document.body.appendChild(retirementContainer);

      const root = ReactDOM.createRoot(retirementContainer);

      const closeForm = () => {
        root.unmount();
        if (document.body.contains(retirementContainer)) {
          document.body.removeChild(retirementContainer);
        }
      };

      root.render(
        <FormRetirements
          _credit_name={credit_name}
          _balance={balance}
          onClose={closeForm}
          onSubmit={async (formData) => {
            try {
              const requiredFields = [
                'credit_name',
                'quantity',
                'beneficiary',
                'purpose',
                'wilder_user',
                'password',
                'pin',
              ];
              const missingFields = requiredFields.filter((field) => !formData[field]);

              if (missingFields.length > 0 || !formData.confirmation) {
                showWarning('Campos obrigatórios', 'Preencha todos os campos e confirme a aposentadoria.');
                return;
              }

              closeForm();
              showInfo('Processando...', 'Aguarde enquanto processamos a aposentadoria dos créditos.');

              const token = sessionStorage.getItem('Authorization');

              // ✅ 1. Autentica o usuário com o serviço centralizado
              await socialCarbonService.authenticateUser(formData.wilder_user, formData.password, token);

              // ✅ 2. Executa a aposentadoria de créditos
              const response = await socialCarbonService.setRetirement(formData, token);
              console.log('Aposentadoria realizada com sucesso:', response);

              // ✅ 3. Recarrega a sessão
              recarregar(formData.wilder_user, formData.password, formData.pin);

              hideModal();
              showSuccess('Aposentadoria realizada!', 'Os créditos foram aposentados com sucesso.');
            } catch (error) {
              console.error('Erro ao aposentar crédito:', error);
              hideModal();
              showError('Erro ao aposentar crédito', error.response?.data?.error || 'Algo deu errado. Tente novamente.');
            }
          }}
        />
      );

      const style = document.createElement('style');
      style.textContent = `
      #retirement-form-container {
        border-radius: 10px;
      }
    `;
      document.head.appendChild(style);
    } catch (error) {
      console.error('Erro ao exibir formulário de aposentadoria:', error);
      showError('Erro', 'Ocorreu um erro ao abrir o formulário de aposentadoria.');
    }
  };

  const formatDate = (dateString) => {
    return format(new Date(dateString), 'dd/MM/yyyy HH:mm:ss');
  };

  return (
    <Card>
      <CardHeader>
        Conta: <span>{account.address.slice(0, 12)}...</span>
      </CardHeader>

      <CardContent><strong>Balance:</strong> {account.balance}</CardContent>
      <CardContent><strong>Criado:</strong> {formatDate(account.created)}</CardContent>
      <CardContent><strong>Modificado:</strong> {formatDate(account.modified)}</CardContent>
      <CardContent><strong>Dono:</strong> {account.owner}</CardContent>
      <CardContent><strong>Ticker:</strong> {account.ticker}</CardContent>
      <CardContent><strong>Total:</strong> {account.total}</CardContent>
      <CardContent><strong>Tipo:</strong> {account.type}</CardContent>
      <CardContent><strong>Versão:</strong> {account.version}</CardContent>

      <ButtonGrid>
        <StyledButton onClick={() => showAsset(account.address)}>Asset</StyledButton>
        <StyledButton onClick={() => showProject(account.address)}>Project</StyledButton>
        <StyledButton onClick={() => { showRetirements(account.address); }} > Retirement </StyledButton>
        <StyledButton onClick={() => showRetirementForm(account.ticker, account.total)}> Aposentar Crédito </StyledButton>
      </ButtonGrid>
    </Card>
  );
};

export default AccountCard;
